import { render, staticRenderFns } from "./AssignedUsersQuotations.vue?vue&type=template&id=51275a62&scoped=true&"
import script from "./AssignedUsersQuotations.vue?vue&type=script&lang=js&"
export * from "./AssignedUsersQuotations.vue?vue&type=script&lang=js&"
import style0 from "./AssignedUsersQuotations.vue?vue&type=style&index=0&id=51275a62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51275a62",
  null
  
)

export default component.exports